<template>
  <div>
    <slot name="header"></slot>
    <div class="wrapper">
      <div class="content">
        <template v-if="!isRegisterSuccess">
          <div class="center" style="margin-bottom: 60px">
            <v-img
              width="300px"
              max-width="300px"
              src="@/assets/img_register.png"
            ></v-img>
          </div>
          <h1 class="heading PSLKanda4Pro primary--text">
            {{ $t("welcome") }}!
          </h1>
          <div class="PSLKanda4Pro" style="margin-bottom: 32px">
            {{ $t("intro_register") }}
          </div>
          <ProfileForm
            :type="'add'"
            @onSubmitRegister="onSubmitRegister"
          ></ProfileForm>
        </template>
        <template v-else>
          <div class="center" style="margin-bottom: 60px">
            <v-img
              width="300px"
              max-width="300px"
              src="@/assets/img-register-success.png"
            ></v-img>
          </div>
          <div
            style="font-size: 24px; font-weight: bold;"
            class="primary--text text-center PSLKanda4Pro"
          >
            {{ $t("registration_successfully") }}!
          </div>
          <div class="text-center" style="margin-top: 64px">
            <v-btn class="btn-purple" dark width="200px" rounded @click="close">
              {{ $t("close") }}
            </v-btn>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import ProfileForm from "@/components/ProfileForm.vue";

export default {
  components: {
    ProfileForm,
  },
  data() {
    return {
      isRegisterSuccess: false,
    };
  },
  mounted() {
    let vm = this;
    vm.scrollTop();
  },
  methods: {
    async onSubmitRegister() {
      let vm = this;
      vm.isRegisterSuccess = true;
    },
    close() {
      let vm = this;
      if (vm.query.apptype == "line") {
        vm.$liff.closeWindow();
      } else {
        vm.$store.dispatch("messengerClose");
      }
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        // behavior: 'smooth'
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  height: 100%;
}
.content {
  padding: 120px 24px 24px;
  max-width: 500px;
  margin: 0 auto;
}
</style>
